"use client";
import styles from "@/styles/NavigationHelper.module.scss";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import useLocalStorageBoolean from "@/app/hooks/useLocalStorageBoolean";
import { useEffect, useMemo, useState } from "react";
import { isTouchDevice } from "@/app/common/Utils";

export const NavigationHelper = ({ show, setShow, visibleMethod }: { show: boolean; setShow: (show: boolean) => void; visibleMethod: (isVisible: boolean) => void }) => {
	const [showHelperNav, setShowHelperNav] = useLocalStorageBoolean("helperNav", "true");

	const [isTouch, setIsTouch] = useState(false);

	useEffect(() => {
		visibleMethod(showHelperNav);
	}, [visibleMethod, showHelperNav]);

	useEffect(() => {
		if (show) {
			setShowHelperNav(show); // Zeige den NavigationHelper erneut an
		}
	}, [show, setShowHelperNav]);

	useEffect(() => {
		setIsTouch(isTouchDevice());
	}, []);

	const handleHelperNav = () => {
		setShowHelperNav(false);
		setShow(false);
	};

	return (
		<AnimatePresence>
			<motion.div
				className={styles.navigationOverlay}
				key="poi-navigation"
				initial={{ opacity: 0 }}
				animate={showHelperNav ? { opacity: 1 } : { opacity: 0, pointerEvents: "none" }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.5 }}
			>
				<div className={styles.navigationOverlayInner}>
					<h3 className="margin-bottom">IN 3D NAVIGIEREN</h3>

					{/** Is Touch Device */}
					<div className="flex flex-align-v-bottom margin-top margin-bottom">
						<div className={`width-4 ${styles.helperItem}`}>
							<figure>
								<Image
									src={isTouch ? "/static/images/helper/mobile_helper_image_rotation.png" : "/static/images/helper/desktop_helper_image_rotation.png"}
									alt="Rotation der Scene"
									width={80}
									height={0}
									style={{
										width: "60%", // Setzt die Breite auf 80%
										height: "auto", // Beibehaltung des Seitenverhältnisses
									}}
								/>
								<figcaption className="translate">ROTIEREN</figcaption>
							</figure>
						</div>
						<div className={`width-4 ${styles.helperItem}`}>
							<figure>
								<Image
									src={isTouch ? "/static/images/helper/mobile_helper_image_scale.png" : "/static/images/helper/desktop_helper_image_scale.png"}
									alt="Skalieren der Scene"
									width={80}
									height={0}
									style={{
										width: "60%", // Setzt die Breite auf 80%
										height: "auto", // Beibehaltung des Seitenverhältnisses
									}}
								/>
								<figcaption className="translate">SKALIEREN</figcaption>
							</figure>
						</div>
						<div className={`width-4 ${styles.helperItem}`}>
							<figure>
								<Image
									src={isTouch ? "/static/images/helper/mobile_helper_image_move.png" : "/static/images/helper/desktop_helper_image_move.png"}
									alt="Bewegen der Scene"
									width={80}
									height={0}
									style={{
										width: "60%", // Setzt die Breite auf 80%
										height: "auto", // Beibehaltung des Seitenverhältnisses
									}}
								/>
								<figcaption className="translate">BEWEGEN</figcaption>
							</figure>
						</div>
					</div>

					<button className="margin-top translate" onClick={handleHelperNav}>
						Alles klar
					</button>
				</div>
			</motion.div>
		</AnimatePresence>
	);
};
